var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23C17.8513 23 23 17.8513 23 11.5ZM12.9375 5.75C12.9375 4.95609 12.2939 4.3125 11.5 4.3125C10.7061 4.3125 10.0625 4.95609 10.0625 5.75C10.0625 6.54391 10.7061 7.1875 11.5 7.1875C12.2939 7.1875 12.9375 6.54391 12.9375 5.75ZM11.5 18.6875C10.7061 18.6875 10.0625 18.0439 10.0625 17.25V11.5C10.0625 10.7061 10.7061 10.0625 11.5 10.0625C12.2939 10.0625 12.9375 10.7061 12.9375 11.5V17.25C12.9375 18.0439 12.2939 18.6875 11.5 18.6875Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationBlackIcon);
export default __webpack_public_path__ + "static/media/information-black-icon.a85f78541e5e122b414ad41bcc33d269.svg";
export { ForwardRef as ReactComponent };